export enum UserType {
  USER = 'USER',
  WORKER = 'WORKER'
}
